/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
  PatchApiV1ExamRevisionLangBotexamlangidActivePathParams,
  PatchApiV1ExamRevisionLangBotexamlangidActive400,
  PatchApiV1ExamRevisionLangBotexamlangidActive401,
  PatchApiV1ExamRevisionLangBotexamlangidActive404,
  PatchApiV1ExamRevisionLangBotexamlangidActive500,
} from "../../types/examRevisionController/PatchApiV1ExamRevisionLangBotexamlangidActiveActive.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1ExamRevisionLangBotexamlangidActiveActive } from "../../clients/examRevisionController/patchApiV1ExamRevisionLangBotexamlangidActiveActive.ts";

export const patchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationKey =
  () =>
    [
      { url: "/api/v1/exam/revision/lang/:botExamLangId/active/:active" },
    ] as const;

export type PatchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationKey =
  ReturnType<
    typeof patchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationKey
  >;

export function patchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationKey();
  return mutationOptions<
    PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ExamRevisionLangBotexamlangidActive400
      | PatchApiV1ExamRevisionLangBotexamlangidActive401
      | PatchApiV1ExamRevisionLangBotexamlangidActive404
      | PatchApiV1ExamRevisionLangBotexamlangidActive500
    >,
    {
      botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"];
      active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ botExamLangId, active }) => {
      return patchApiV1ExamRevisionLangBotexamlangidActiveActive(
        botExamLangId,
        active,
        config,
      );
    },
  });
}

/**
 * @description Ativa ou inativa um idioma de prova gerada por IA e todas as suas questões e opções em cascata. Passe 'true' para habilitar e 'false' para desabilitar. Retorna 404 se o idioma não for encontrado. **(Requer Authorization para autenticação)**
 * @summary Habilitar ou desabilitar idioma de prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/active/:active}
 */
export function usePatchApiV1ExamRevisionLangBotexamlangidActiveActive<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1ExamRevisionLangBotexamlangidActive400
        | PatchApiV1ExamRevisionLangBotexamlangidActive401
        | PatchApiV1ExamRevisionLangBotexamlangidActive404
        | PatchApiV1ExamRevisionLangBotexamlangidActive500
      >,
      {
        botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"];
        active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationKey();

  const baseOptions =
    patchApiV1ExamRevisionLangBotexamlangidActiveActiveMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1ExamRevisionLangBotexamlangidActive400
        | PatchApiV1ExamRevisionLangBotexamlangidActive401
        | PatchApiV1ExamRevisionLangBotexamlangidActive404
        | PatchApiV1ExamRevisionLangBotexamlangidActive500
      >,
      {
        botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"];
        active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"];
      },
      TContext
    >;

  return useMutation<
    PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ExamRevisionLangBotexamlangidActive400
      | PatchApiV1ExamRevisionLangBotexamlangidActive401
      | PatchApiV1ExamRevisionLangBotexamlangidActive404
      | PatchApiV1ExamRevisionLangBotexamlangidActive500
    >,
    {
      botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"];
      active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1ExamRevisionLangBotexamlangidActiveMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ExamRevisionLangBotexamlangidActive400
      | PatchApiV1ExamRevisionLangBotexamlangidActive401
      | PatchApiV1ExamRevisionLangBotexamlangidActive404
      | PatchApiV1ExamRevisionLangBotexamlangidActive500
    >,
    {
      botExamLangId: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["botExamLangId"];
      active: PatchApiV1ExamRevisionLangBotexamlangidActivePathParams["active"];
    },
    TContext
  >;
}
